<template>
    <b-modal
        id="changeAWB-modal"
        ref="changeAWB-modal"
        :title="$t('history.modal.header.ChangeAWB')"
        @show="reset"
        @hidden="reset"
        @ok="handleOk"
    >
        <form ref="form" @submit.stop.prevent="handleSubmit">
            <b-form-group
                :label="$t('history.modal.body.NewAWB')"
                :invalid-feedback="invalidFeedback"
            >
                <b-form-input
                    v-model="awb"
                    :state="awbState"
                    required
                    name="changeAWBModalInput"
                ></b-form-input>
            </b-form-group>
        </form>

        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button @click="cancel()">
                Cancel
            </b-button>
            <b-button @click="ok()" name="changeAWBModalModalButton" variant="primary">
                {{ $t('history.modal.button.Change') }}
            </b-button>
        </template>
    </b-modal>
</template>
<script>
import { CORE_PREFIX, ACTIONS, MUTATIONS, HISTORY_PREFIX } from '@/store/constants';
import helpers from '@/helper';

export default {
    components: {},

    props: {
        shipment: { type: Object, required: true }
    },

    data() {
        return {
            awb: '',
            awbState: null,
            invalidFeedback: ''
        };
    },

    methods: {
        showChangeAWBModal() {
            this.$refs['changeAWB-modal'].show();
        },

        handleOk(bvModalEvt) {
            bvModalEvt.preventDefault();
            this.changeAWB();
        },

        async changeAWB() {
            if (!this.$refs.form.checkValidity()) {
                this.awbState = false;
                this.invalidFeedback = 'AWB is required';
                return;
            }

            let obj = { shipment: this.shipment, awb: this.awb };

            const response = await this.$store.dispatch(
                HISTORY_PREFIX + ACTIONS.HISTORY.UPDATE_SHIP_AWB,
                obj
            );

            if (response.data.error) {
                this.invalidFeedback = response.data.errorMessage;
                this.awbState = false;
            } else {
                this.shipment.shipmentRef = this.awb;
                this.$bvModal.hide('changeAWB-modal');
            }
        },

        reset() {
            this.awb = '';
            this.awbState = null;
        }
    }
};
</script>

<style></style>
